/**
 * CanvasGuard Component
 * Route guard that handles mobile/tablet users accessing canvas editor
 *
 * Usage: Wrap canvas routes in AppRouter.tsx with this guard
 * Pattern: Similar to AuthGuard, but checks device type instead of auth status
 *
 * Behavior:
 * - True phone users get the dedicated mobile board flow
 * - Tablet and desktop users always get the full canvas editor
 */

import React from 'react'
import { useMobileDetection } from '../../hooks/useMobileDetection'
import { MobileBoardFlow } from '../mobile/MobileBoardFlow'

interface CanvasGuardProps {
  children: React.ReactNode
}

/** Guard component that routes only phone users into the mobile board flow. */
export function CanvasGuard({ children }: CanvasGuardProps) {
  const { isPhone } = useMobileDetection()

  if (isPhone) {
    return <MobileBoardFlow />
  }

  return <>{children}</>
}

export default CanvasGuard
